import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type TagEmptyProps = {
    className?: string;
};

const TagEmpty: FunctionComponent<TagEmptyProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'tag-empty'}
            viewBox="0 0 250 250"
        >
            <path d="M136.7 61.5c-12.5-6.9-28.5-2.4-35.4 10.2-7 12.6-2.4 28.5 10.2 35.4 12.6 7 28.5 2.4 35.4-10.2 7-12.6 2.4-28.5-10.2-35.4zm4.1 32c-5.1 9.2-16.7 12.5-25.9 7.5-9.2-5.1-12.5-16.7-7.5-25.9 5.1-9.2 16.7-12.5 25.9-7.5 9.3 5.1 12.6 16.7 7.5 25.9z" />
            <path d="M213.6 79.4c0-4.1-1.8-8-4.9-10.8L135.2 3.5c-5.4-4.8-13.6-4.8-19.1 0l-73.4 65c-3.1 2.8-4.9 6.7-4.8 10.8v156.6c0 8 6.4 14.4 14.4 14.4h146.8c8 0 14.4-6.4 14.4-14.4l.1-156.5zm-9.5 160.7c-1.2 1.4-3 2.2-4.9 2.2H52.4c-1.7 0-3.4-.6-4.6-1.9-1.3-1.2-1.9-2.9-2-4.6V79.1c0-1.6.6-3.2 1.6-4.3.2-.2.3-.4.5-.6l73.4-65c2.4-2.2 6.1-2.2 8.6 0l73.4 64.9c1.5 1.4 2.3 3.1 2.3 4.9l.1 156.6c.1 1.8-.5 3.4-1.6 4.5z" />
        </svg>
    );
};
export default TagEmpty;
